import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export const getMonthName = (monthNumber) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return months[monthNumber - 1];
};

export const dateDifference = (dateFrom, dateTo) => {
  const from = dayjs(dateFrom, "YYYY-MM-DD");
  const to = dayjs(dateTo, "YYYY-MM-DD");

  return to.diff(from, "days");
};

export const formatDuration = (seconds) => {
  const dur = dayjs.duration(seconds, "seconds");

  const days = dur.days();
  const hours = dur.hours();
  const minutes = dur.minutes();

  let result = "";
  if (days > 0) result += `${days} days `;
  if (hours > 0) result += `${hours} h `;
  if (minutes > 0) result += `${minutes} min`;

  return result.trim();
};

export const today = dayjs().format("YYYY-MM-DD");

export const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

export const formatShortDate = (date) => {
  if (!date) return null;
  return dayjs(date).format("MM/DD");
};
